import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { RollingLoader } from "../../../commons";

type AppProps = {
  showAddTemplateModal: boolean;
  toogleAddTemplateModal: () => void;
  templateName: string;
  uniqueTemplateNameMessage: string;
  templateFetching: boolean | undefined;
  handleTemplateNameChange: (e: any) => void;
  handleAddTemplate: (e?: number) => void;
};

const BomAddTemplateModal = ({
  showAddTemplateModal,
  uniqueTemplateNameMessage,
  toogleAddTemplateModal,
  templateName,
  templateFetching,
  handleAddTemplate,
  handleTemplateNameChange,
}: AppProps) => {
  return (
    <div>
      <Modal isOpen={showAddTemplateModal} toggle={toogleAddTemplateModal}>
        <ModalHeader className="pt-4 pl-4">Add Template</ModalHeader>
        <ModalBody className="pl-4 pr-4">
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="foldername"
                  className={templateName ? "active" : ""}
                >
                  Enter Template Name
                </label>
                <div className="d-flex flex-row position-relative">
                  <input
                    type="text"
                    className={`form-control`}
                    name="text"
                    value={templateName}
                    autoFocus
                    onChange={(e) => handleTemplateNameChange(e)}
                  />
                  {templateFetching && <RollingLoader />}
                </div>
                {uniqueTemplateNameMessage?.includes(
                  "Template name already exists"
                ) && (
                  <small className="text-danger">
                    Template Name is already in use!
                  </small>
                )}
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <span className="pointer" onClick={toogleAddTemplateModal}>
            Cancel
          </span>
          <Button
            color="primary ml-3"
            onClick={(e: any) => {
              handleAddTemplate(1);
              toogleAddTemplateModal();
            }}
            disabled={
              uniqueTemplateNameMessage?.includes(
                "Template name already exists"
              ) || !templateName?.trim()?.length
            }
          >
            Add Template
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default BomAddTemplateModal;
